import anime from 'animejs';
import { bindMethod } from 'helpers/bind';
import { EASE_IN, EASE_OUT } from 'helpers/easings';
import Component from 'navigation/component/Component';
import store from 'store';
import sizeStore from 'store/sizeStore';
class Notification extends Component {
    animation = null;
    constructor(el, options) {
        super(el, options);
        this.bindEvents();
    }
    initialized() {
        super.initialized();
        this.resize();
        if (this.refs.notificationLinks.length > 1) {
            this.initAnimation();
        }
        else {
            anime.set(this.refs.notificationLinks[0], {
                translateY: '-50%',
                translateX: 0,
                opacity: 1
            });
            this.refs.notificationLinks[0].classList.add('active');
        }
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        this.refs.toggleStoreLocator.forEach((button) => {
            button[method]('click', (e) => this.onToggleStoreLocatorClick(e));
        });
        this.el[method]('mouseenter', this.onMouseEnter);
        this.el[method]('mouseleave', this.onMouseLeave);
    }
    onToggleStoreLocatorClick = (e) => {
        store.drawer.set('webstore-switcher');
    };
    resize() {
        const height = this.el.offsetHeight;
        sizeStore.notificationHeight.set(height);
    }
    initAnimation() {
        const tl = anime.timeline({ loop: true, duration: this.refs.notificationLinks.length * 2000 });
        const duration = 800;
        for (let i = 0; i < this.refs.notificationLinks.length; i++) {
            const link = this.refs.notificationLinks[i];
            tl.add({
                targets: link,
                translateY: ['-50%', '-50%'],
                translateX: [-10, 0],
                opacity: [0, 1],
                duration,
                easing: EASE_OUT,
                changeBegin: () => {
                    link.classList.add('active');
                }
            }).add({
                targets: link,
                translateY: ['-50%', '-50%'],
                translateX: [0, 10],
                opacity: [1, 0],
                duration,
                easing: EASE_IN,
                pointerEvents: 'none',
                changeBegin: () => {
                    setTimeout(() => {
                        link.classList.remove('active');
                    }, 500);
                }
            }, '+=1500');
        }
    }
    onMouseEnter = () => {
        if (this.animation)
            this.animation.pause();
    };
    onMouseLeave = () => {
        if (this.animation)
            this.animation.play();
    };
}
export default Notification;
